import styled from '@src/styled-components';
import React from 'react';

export interface ISampleTextExecutionProps {
  title: string;
}

export default class SampleTextExecutionComponent extends React.Component<ISampleTextExecutionProps, any> {
  constructor(props: ISampleTextExecutionProps) {
    super(props);
  }

  formatHTML() {
    return { __html: this.props.title };
  }

  render() {
    return (
      <Wrapper>
        <React.Fragment>
          <p dangerouslySetInnerHTML={this.formatHTML()} />
        </React.Fragment>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
  }
`